import { ZIP_CODE_PATH, USER_STORE_PATH, B2C_USER_ADDRESSES_PATH, } from '../../constants/links';
import { apiBase, apiB2C } from '../axios-client';
export var addressesApi = {
    getPostalList: function (code) {
        // eslint-disable-next-line consistent-return
        return apiBase.get("".concat(ZIP_CODE_PATH, "/").concat(code)).then(function (_a) {
            var _b;
            var data = _a.data;
            if (data && ((_b = data.postalDetailsList) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                return data.postalDetailsList;
            }
            throw new Error('postalDetailsList is empty');
        });
    },
    getStore: function (localStoreId) {
        return apiBase.get("".concat(USER_STORE_PATH).concat(localStoreId)).then(function (_a) {
            var data = _a.data;
            return data;
        });
    },
    getDefaultAddress: function () {
        return apiB2C
            .get(B2C_USER_ADDRESSES_PATH, {
            params: {
                pageSize: 0,
                pageNumber: 0,
            },
        })
            .then(function (_a) {
            var _b, _c;
            var data = _a.data;
            var address = (_c = (_b = data === null || data === void 0 ? void 0 : data.addresses) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c[0];
            if (address === null || address === void 0 ? void 0 : address.isDefault) {
                return address;
            }
            throw new Error('getDefaultAddress: no default address');
        });
    },
    addAddress: function (address) {
        return apiB2C.post(B2C_USER_ADDRESSES_PATH, {
            addresses: {
                address: [address],
            },
        });
    },
    editAddress: function () {
        var addresses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            addresses[_i] = arguments[_i];
        }
        return apiB2C.put(B2C_USER_ADDRESSES_PATH, {
            addresses: {
                address: addresses,
            },
        });
    },
};
